import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomMaterialModule } from 'src/app/material-module/material.module';
import { CustomFormControlsModule } from 'src/app/shared/custom-form-controls/custom-form-controls.module';
import { ResourcefulIndexModule } from 'src/app/shared/resourceful-index/resourceful-index.module';
import { RicercaIspettoratiModule } from './search/ricerca-ispettorati.module';
import { IspettoratiFormComponent } from './dialogs/form/form.component';
import { IspettoratiRoutingModule } from './ispettorati-routing.module';
import { IspettoratiComponent } from './ispettorati.component';



@NgModule({
  declarations: [IspettoratiComponent, IspettoratiFormComponent],
  imports: [
    CommonModule,
    IspettoratiRoutingModule,
    CustomMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    CustomFormControlsModule,
    ResourcefulIndexModule,
    RicercaIspettoratiModule,
  ]
})
export class IspettoratiModule { }
